import { useMemo } from "react";
import type { Information } from "@/shared/lib/api/api-client";

const APP_DISPLAY_LIMIT = 10;

interface UseInformationAppDisplayOptions {
	items: Information[];
}

interface UseInformationAppDisplayReturn {
	appDisplayContents: Information[];
	isInAppDisplay: (id: number) => boolean;
}

export const useInformationAppDisplay = ({
	items,
}: UseInformationAppDisplayOptions): UseInformationAppDisplayReturn => {
	const appDisplayContents = useMemo(() => {
		const now = new Date();
		return [...items]
			.filter((info) => new Date(info.date) <= now)
			.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
			.slice(0, APP_DISPLAY_LIMIT);
	}, [items]);

	const isInAppDisplay = useMemo(() => {
		const displayIds = new Set(appDisplayContents.map((item) => item.id));
		return (id: number) => displayIds.has(id);
	}, [appDisplayContents]);

	return {
		appDisplayContents,
		isInAppDisplay,
	};
};
